const OCconfigurationMenu = [
    {
        icon: "build",
        key: "acd.groups",
        name: "ACD Groups",
        url: "home/app/acdGroups",
        description: "Configuration of ACD Groups Type Extension",
        disabled: false, 
        productionReady : true
      },

      {
        icon: "moped",
        key: "define.operator",
        name: "Define Operator",
        url: "home/app/define-operator",
        description: "Configuration of define-operator",
        disabled: false, 
        productionReady : true
      },
  ];
  
  export { OCconfigurationMenu };
  